import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { useAuthStore } from "@/lib/auth/store";
import { ROLES } from "@/lib/auth/rbac";
import Login from "@/pages/Login";
import Blocked from "@/pages/Blocked";
import Dashboard from "@/pages/Dashboard";
import TenantsPage from "@/pages/Tenants/TenantsPage";
import TenantDetailPage from "@/pages/Tenants/TenantDetailPage";
import UsersPage from "@/pages/Users/UsersPage";

/**
 * Platform-admin gate: requires a session AND the SUPER_ADMIN role.
 * Restaurant staff get a friendly blocked screen instead of the app shell.
 */
function RequireSuperAdmin({ children }: { children: React.ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const role = useAuthStore((s) => s.user?.role);
  if (!accessToken) return <Navigate to="/login" replace />;
  if (role !== ROLES.SUPER_ADMIN) return <Blocked />;
  return <>{children}</>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireSuperAdmin>
            <AppShell />
          </RequireSuperAdmin>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/tenants/:id" element={<TenantDetailPage />} />
        <Route path="/users" element={<UsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
